
<div class="container">
  <h1>اللجان الطبية</h1>


  <!-- Dropdown -->
  <select [(ngModel)]="selectedId" (change)="onDropdownChange()">
    <option value="">-- Select --</option>
    <option *ngFor="let item of dropdownList" [value]="item.key">
      {{ item.value }}
    </option>
  </select>

  <!-- Loading -->
 <div class="overlay-wrapper" *ngIf="loading">
  <p-progressSpinner></p-progressSpinner>
</div>

<!-- Search -->
<input
  *ngIf="items.length > 0"
  type="text"
  placeholder="بحث..."
  [(ngModel)]="searchText"
  class="search-input"
/>

  <!-- List -->
  <div *ngIf="items.length > 0" class="items-container">

  <div class="card" *ngFor="let item of filteredItems">

    <div class="card-content">

      <div class="info">
        <div class="name">{{ item.value }}</div>
        <div class="code">{{ item.key }}</div>
      </div>

      <label class="switch">
       <input
  type="checkbox"
  [(ngModel)]="item.isActive"
/>
        <span class="slider"></span>
      </label>

    </div>

  </div>

</div>

  <!-- Empty State -->
  <div *ngIf="!loading && (items.length === 0 || filteredItems.length === 0)" class="empty">
    لا توجد بيانات
  </div>

  <!-- Update Button -->
  <button (click)="openAddDoctor()">إضافة طبيب</button> 
  <button (click)="openConfirm()" [disabled]="!items.length">
  تحديث
</button>

<!-- CONFIRM MODAL -->
<div class="modal-overlay" *ngIf="showConfirm">
  <div class="modal-box">

    <h3>تأكيد العملية</h3>
    <p>هل أنت متأكد أنك تريد التحديث؟</p>

    <div class="modal-actions">
      <button class="btn cancel" (click)="showConfirm = false">
        لا
      </button>
      <button class="btn confirm" (click)="confirmUpdate()">
        نعم
      </button>
    </div>

  </div>
</div>

</div>

<!-- ADD DOCTOR MODAL -->
<div class="modal-overlay" *ngIf="showAddDoctor" (click)="showAddDoctor=false">
  <div class="modal-box" (click)="$event.stopPropagation()">

    <h3>إضافة طبيب</h3>

    <!-- Dropdown -->
  <div class="form-group">
  <select [(ngModel)]="newDoctor.committeeType">
    <option value="">-- اختر نوع اللجنة --</option>
    <option *ngFor="let item of dropdownList" [value]="item.key">
      {{ item.value }}
    </option>
  </select>
</div>

<div class="form-group">
  <input
    type="text"
    placeholder="اسم الطبيب"
    [(ngModel)]="newDoctor.drName"
  />
</div>

<div class="form-group">
  <input
    type="text"
    placeholder="تخصص الطبيب"
    [(ngModel)]="newDoctor.jurisdiction"
  />
</div>

    <div class="modal-actions">
      <button class="btn cancel" (click)="showAddDoctor = false">
        إلغاء
      </button>

     <button 
  class="btn confirm"
  (click)="createDoctor()"
  [disabled]="!newDoctor.committeeType || !newDoctor.drName || !newDoctor.jurisdiction">
  إضافة
</button>
    </div>

  </div>
</div>